var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMegaphoneSimple = function SvgIconMegaphoneSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.532 2.91c.285-.054.58-.04.859.04l.005.001L13.1 5.488q.093.019.18.053l7.612 2.218.003.001a1.875 1.875 0 0 1 1.356 1.804v3.372a1.875 1.875 0 0 1-1.356 1.804l-.003.001-2.391.697V18a1.875 1.875 0 0 1-1.875 1.875h-3A1.875 1.875 0 0 1 11.75 18v-.595L4.396 19.55l-.005.002A1.874 1.874 0 0 1 2 17.746V4.754a1.875 1.875 0 0 1 1.532-1.845M14 16.75v.875h2.25v-1.531zm0-2.344V8.094l6 1.75v2.813zm-2.25-6.968v7.624l-7.5 2.186V5.252z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.532 2.91c.285-.054.58-.04.859.04l.005.001L13.1 5.488q.093.019.18.053l7.612 2.218.003.001a1.875 1.875 0 0 1 1.356 1.804v3.372a1.875 1.875 0 0 1-1.356 1.804l-.003.001-2.391.697V18a1.875 1.875 0 0 1-1.875 1.875h-3A1.875 1.875 0 0 1 11.75 18v-.595L4.396 19.55l-.005.002A1.875 1.875 0 0 1 2 17.746V4.754a1.875 1.875 0 0 1 1.532-1.845M14 16.75v.875h2.25v-1.531zm0-2.344V8.094l6 1.75v2.813zm-2.25-6.968v7.624l-7.5 2.186V5.252z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMegaphoneSimple;